var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PracticeSettings',{attrs:{"pager-config":_vm.pagerConfig,"models":_vm.models}})}
var staticRenderFns = []

export { render, staticRenderFns }